import { Dimensions, StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  viewBase: {
    flex: 1,
  },
  scroll: {
    marginHorizontal: pixelDimensions(1.75),
  },
  cardCalendar: {
    borderRadius: pixelDimensions(2),
  },
  TitleCalendar: {
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    padding: pixelDimensions(1.5),
    marginTop: pixelDimensions(1),
    marginBottom: pixelDimensions(2),
  },
  card: {
    padding: pixelDimensions(3),
    marginTop: pixelDimensions(5),
    borderRadius: pixelDimensions(2),
  },
  cardContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  groupButtonsHours: {
    // flexDirection: 'row',
    justifyContent: 'center',
    padding: pixelDimensions(2),
  },
  buttonHour: {
    backgroundColor: Colors.blueGrey600,
    padding: pixelDimensions(1.25),
    margin: pixelDimensions(1.25),
    borderRadius: pixelDimensions(7),
  },
  buttonHourSelected: {
    backgroundColor: appColors.primary,
    padding: pixelDimensions(1.25),
    margin: pixelDimensions(1.25),
    borderRadius: pixelDimensions(7),
  },
  textButtonHour: {
    fontSize: Dimensions.get('window').width < 800 ? pixelDimensions(3.25) : pixelDimensions(2),
    fontWeight: '100',
    color: 'white',
    alignSelf: 'center',
  },
  nextButton: {
    backgroundColor: appColors.primary,
    marginVertical: pixelDimensions(2),
    elevation: 5,
    shadowRadius: 20,
    shadowOpacity: 0.5,
    shadowOffset: {
      height: 2,
      width: 0,
    },
    shadowColor: Colors.black,
  },
  nextButtonDisabled: {
    backgroundColor: appColors.primary,
    opacity: 0.6,
  },
  buttonBack: {
    alignSelf: 'flex-end',
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },

});

export const themeCalendar = {
  selectedDayBackgroundColor: appColors.primary,
};

export default styles;
